import { render, staticRenderFns } from "./ContactsGoogle.vue?vue&type=template&id=cc85b748&scoped=true&"
import script from "./ContactsGoogle.vue?vue&type=script&lang=js&"
export * from "./ContactsGoogle.vue?vue&type=script&lang=js&"
import style0 from "./ContactsGoogle.vue?vue&type=style&index=0&id=cc85b748&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc85b748",
  null
  
)

export default component.exports